import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$data, _vm$data2, _vm$data3, _vm$data4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      title: "补充材料",
      visible: _vm.visible,
      width: "500px",
      "before-close": _vm.handleClose,
      "close-on-click-modal": false,
      "append-to-body": ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("div", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "supplement-section"
  }, [_c("div", {
    staticClass: "wlc-f-c mb10px color-#111"
  }, [_c("div", {
    staticClass: "label",
    staticStyle: {
      color: "#409EFF"
    }
  }, [_vm._v(" 投诉人 ")]), (_vm$data = _vm.data) !== null && _vm$data !== void 0 && _vm$data.avatar ? _c("div", {
    staticClass: "complaint-avatar"
  }, [_c("wlc-image", {
    staticClass: "avatar",
    attrs: {
      src: (_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : _vm$data2.avatar,
      width: "24",
      height: "24",
      enlarged: false
    }
  })], 1) : _vm._e(), (_vm$data3 = _vm.data) !== null && _vm$data3 !== void 0 && _vm$data3.name ? _c("div", {
    staticClass: "complaint-name ml8px"
  }, [_vm._v(" " + _vm._s((_vm$data4 = _vm.data) === null || _vm$data4 === void 0 ? void 0 : _vm$data4.name) + " ")]) : _vm._e()]), _c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "82px",
      model: _vm.form,
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: "补充提示",
      prop: "msg"
    }
  }, [_c("wlc-at-mention-input", {
    attrs: {
      type: "textarea",
      rows: 4,
      placeholder: "输入@+关键词唤醒快捷回复。请输入补充提示，引导用户上传对应资料。",
      maxlength: "100",
      "show-word-limit": "",
      advisoryId: _vm.currentId
    },
    model: {
      value: _vm.form.msg,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "msg", $$v);
      },
      expression: "form.msg"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer flex mt20px justify-end",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary",
      loading: _vm.loading
    },
    on: {
      click: _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };